import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type CurrencyUnit = 'Crore' | 'Rupees';

@Injectable({
  providedIn: 'root'
})
export class UnitToggleService {
  private unitSubject = new BehaviorSubject<CurrencyUnit>('Crore');
  unit$ = this.unitSubject.asObservable();

  setUnit(unit: CurrencyUnit) {
    this.unitSubject.next(unit);
  }
  //getunit by currentunit
  get currentUnit(): CurrencyUnit {
    return this.unitSubject.getValue();
  }
  //getUnit
  getUnit(): CurrencyUnit {
    return this.unitSubject.getValue();
  }
}